/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { FunctionComponent } from 'react';

import { LabelProps } from './Label.types';
import { Label } from './Label.styled';

const LabelComponent: FunctionComponent<LabelProps> = ({
    htmlFor,
    preventFocusOnClick = false,
    children,
    onClick,
    showRequired,
}) => {
    function handleClick(e: React.MouseEvent<HTMLLabelElement, MouseEvent>) {
        if (preventFocusOnClick) {
            e.preventDefault();
        }
        if (onClick) onClick(e);
    }
    return (
        <Label
            showRequired={showRequired}
            onClick={handleClick}
            htmlFor={htmlFor}
        >
            {children}
        </Label>
    );
};

export default LabelComponent;
